import React from 'react';

import { SelectInput} from '@sogei/react-web-components-catalog'
import { observer, inject } from "mobx-react";

import i18next from 'i18next';



@inject("rootStore")
@observer
class ContainerHome extends React.Component {

  constructor(props) {
    super(props);
    this.tipologicaStore = props.rootStore.tipologicaStore;
  
  }

  componentDidMount() {
   
    
  }



  render() {
    
    const containerHome = (props) => {
    
    this.titolo= props.paragrafo.titolo
    this.testo = props.paragrafo.testo

      //console.log("this.values: ", JSON.stringify(this.values));
    

      //console.log("props: ", JSON.stringify(props));
      return (
        <>
                <h2 className="underline">{this.titolo}</h2>
                {this.testo}
        
                </>
              )

    }
    
    return (
      containerHome(this.props)

    );
  }

}







//export default SceltaTipoInvio;

export {ContainerHome}; 